import React, {ReactNode, useState} from 'react';
import { useMediaQuery, useTheme } from '@mui/material'

export interface ModalProviderProps {
    children: ReactNode
};

export interface ModalContextProps {
    modalStatus: Record<string, boolean>
    openModal: Function
    closeModal: Function
    closeAllModals: Function
    mobileWidth: boolean
}

const notInitialized = () => {
    throw new Error("function not yet initialized")
}

export const ModalContext = React.createContext<ModalContextProps>({ modalStatus: {}, openModal: notInitialized, closeAllModals: notInitialized, closeModal: notInitialized, mobileWidth: false })

export function ModalContextProvider({children}: ModalProviderProps) {

    const [modalStatus, setModalStatus] = useState({})

    const openModal = (name) => {
        setModalStatus({ ...modalStatus, [name]: true })
    }

    const closeModal = (name) => {
        setModalStatus({ ...modalStatus, [name]: false })
    }

    const closeAllModals = () => {
        setModalStatus({})
    }

    const theme = useTheme()
    const mobileWidth = useMediaQuery(theme.breakpoints.down('md'))

    const modalContextValue = React.useMemo(() => ({
        modalStatus,
        closeModal,
        openModal,
        closeAllModals,
        mobileWidth
    }), [modalStatus, mobileWidth])

    return (
        <ModalContext.Provider value={modalContextValue} >
            {children}
        </ModalContext.Provider>
    )
}